import React from 'react'
import Fixture from './Components/Fixture'

const FixturePage = () => {
  return (
    <div>
      <Fixture />
    </div>
  )
}

export default FixturePage